import Vue from 'vue'
import App from './modules/App.vue'
import eventBus from './common/eventBus';
import $Shadow from '../../components/shadow/index.js';
import $Alert from '../../components/alert/index.js';
import FastClick from 'fastclick';
import './common/global';
import Monitor from '@/common/monitor.js';
import store from './modules/store';
import {disableIOSScroll, loadSessionGetter} from '@/common/util';
import {reduce} from 'lodash';


import methodInApp from './common/mininComp/methodInApp';
import provinceAndCity from './common/mininComp/provinceAndCity';
// import VConsole from 'vconsole';
// new VConsole();

disableIOSScroll();
if (!window.__PRERENDER_INJECTED) {
    loadSessionGetter();
}

Vue.prototype.$eventBus = eventBus;
Vue.prototype.$Shadow = $Shadow;
Vue.prototype.$Alert = $Alert;
Vue.prototype.$clickMonitor = new Monitor({
    url: '//leads.api.autohome.com.cn/monitor/click',
    list: []
});
window.vm = new Vue({
    el: '#app',
    render: h => h(App),
    mixins: [
        methodInApp,
        provinceAndCity
    ],
    mounted() {
        FastClick.attach(document.body);
        document.dispatchEvent(new Event('render-event'));
        
        setTimeout(() => {
            // 添加tab点击和曝光
            this.$clickMonitor.update(reduce(document.querySelectorAll('.series-tab'), (arr, el) => {
                const callback = function (params) {
                    const id = params.options.el.getAttribute('data-id');
                    const buttonId = `series-tab-${id}-${params.monitor.status}`;
                    return {
                        buttonId,
                        ...store.getClickMonitorParams()
                    };
                };
                arr.push({el, event: 'expose', callback});
                arr.push({el, event: 'click', callback});
                return arr;
            }, []));

            // 添加留资按钮曝光点击上报
            this.$clickMonitor.update(reduce([document.querySelector('#submit')], (arr, el) => {
                const callback = function (params) {
                    return {
                        buttonId: `submit-${params.monitor.status}`,
                        ...store.getClickMonitorParams()
                    };
                };
                arr.push({el, event: 'expose', callback});
                arr.push({el, event: 'click', callback});
                return arr;
            }, []));

        }, 200);
    }
});

import { sidebarInit } from '../../lib/sidebar-component';
// 初始化侧边栏插件
sidebarInit({
    style: {
        headBgColor: 'transparent',
        headBg: 'linear-gradient(135deg, #ffa800 0%, #ff3c00 100%)'
    }
});

